export enum ESocialShare {
  "Facebook" = "Facebook",
  "Twitter" = "Twitter",
  "Linkedin" = "Linkedin",
  "CopyLink" = "Copy Link",
  "Custom" = "Custom",
}

export const customSocialShareLabels = [
  ESocialShare.CopyLink,
  ESocialShare.Custom,
];
